import { decimalFormat, percentFormat, translate } from '../../utils';
import { PortfolioChangePercentage } from './PortfolioChangePercentage';

/** @param {{ rank: number, hotel: import('./portfolioDashboard.types').PortfolioHotelRanking, currency: string }} props */
export const PortfolioHotelRankingRow = function PortfolioHotelRankingRow({ rank, hotel, currency }) {
    return (
        <tr>
            <td className="w-px no-br text-muted">{rank}</td>

            <td className="portfolio-dashboard__hotel-name-cell">
                <div title={hotel.name}>{hotel.name}</div>
                <div className="text-muted font-size-12">{hotel.city}</div>
            </td>

            <td className="text-right">
                <div>{percentFormat(hotel.occupancy, 1)}</div>
                <div className="font-size-11 no-br">
                    <PortfolioChangePercentage changePercentage={hotel.previousOccupancyChangePercentage} />
                    <span className="text-muted mx-1">|</span>
                    <PortfolioChangePercentage changePercentage={hotel.nextOccupancyChangePercentage} />
                </div>
            </td>

            <td className="text-right">
                <div>{decimalFormat(hotel.revenue, 2)} {currency}</div>
                <div className="font-size-11 no-br">
                    <PortfolioChangePercentage changePercentage={hotel.previousRevenueChangePercentage} />
                    <span className="text-muted mx-1">|</span>
                    <PortfolioChangePercentage changePercentage={hotel.nextRevenueChangePercentage} />
                </div>
            </td>

            <td className="text-right">
                <div>{decimalFormat(hotel.adr, 2)} {currency}</div>
                <div className="font-size-11 no-br">
                    <PortfolioChangePercentage changePercentage={hotel.previousAdrChangePercentage} />
                    <span className="text-muted mx-1">|</span>
                    <PortfolioChangePercentage changePercentage={hotel.nextAdrChangePercentage} />
                </div>
            </td>

            <td className="text-right">
                <div>{decimalFormat(hotel.revPAR, 2)} {currency}</div>
                <div className="font-size-11 no-br">
                    <PortfolioChangePercentage changePercentage={hotel.previousRevPARChangePercentage} />
                    <span className="text-muted mx-1">|</span>
                    <PortfolioChangePercentage changePercentage={hotel.nextRevPARChangePercentage} />
                </div>
            </td>

            <td className="text-right">
                <div>
                    {translate('frontend', 'PORTFOLIO_DASHBOARD_OCCUPIED_ROOMS_VALUE', {
                        occupiedRoomCount: hotel.occupiedRoomCount,
                        roomCount: hotel.roomCount,
                    })}
                </div>
                <div className="font-size-11 no-br">
                    <PortfolioChangePercentage changePercentage={hotel.previousOccupiedRoomCountChangePercentage} />
                    <span className="text-muted mx-1">|</span>
                    <PortfolioChangePercentage changePercentage={hotel.nextOccupiedRoomCountChangePercentage} />
                </div>
            </td>
        </tr>
    );
};
